define('views/linkedcards/editlinkedcard',[
    "backbone",
    "text!views/linkedcards/editlinkedcard.html",
    "views/_base/baseview",
    "models/linkedcards/linkedcard"
], function (Backbone, Template, BaseView, LinkedCard) {
    "use strict";

    return BaseView.extend({
        template   : _.template(Template),
        id         : "editLinkedCard",
        tagName    : "section",
        scrollToTop: false,
        isRender   : true,
        needsAuth  : true,
        events     : {
            "click .js-removeLinkedCard": "removeLC",
            "click .js-saveNickname"    : "saveLC",
        },
        initialize : function (options) {
            options = options || {};
            this.LCGUID = options.LCG;
            this.NickName = options.NN;
            this.Identifier = options.I;
            this.LCEvents = options.LCE;
            this.LCView = options.LCV;

            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        render: function (showDialogue) {
            var data = {
                lcGUID    : this.LCGUID,
                nickname  : this.NickName,
                identifier: this.Identifier
            };
            this.$el.html(this.template({ data: data }));

            var that = this;

            if(showDialogue == true){
                pfdialog.confirm({
                    context: this,
                    Title  : "Unlink Card",
                    Body   : "Are you sure you want to unlink your card? You will cease to receive rebates for this card once you unlink it.",
                    okButtonText: "Yes",
                    cancelButtonText: "No",
                    okCallback: function(){
                        that.$(".js-removeLinkedCard").attr('disabled', true);
                        that.$(".js-removeLinkedCard").addClass("btn-showSpinner");
                        var data = { guid: that.LCGUID };

                        $.ajax({
                            type : "POST",
                            url  : pf.consumerURL + "/RemoveLinkedCard",
                            async: false,
                            data : JSON.stringify(data),
                            contentType: "application/json",
                            success: function (response) {
                                if (response) {
                                    that.$(".js-removeLinkedCard").removeClass("btn-showSpinner").attr('disabled', false);
                                    //jAlert("Card unlinked successfully");
                                    pfdialog.alert({
                                        context: this,
                                        okButtonText: "OK",
                                        Body: "Card unlinked successfully.",
                                        Title: "Success"
                                    });
                                    that.LCEvents.trigger("refreshCards");
                                    $.fancybox.close();
                                }
                                else {
                                    that.$(".js-removeLinkedCard").removeClass("btn-showSpinner").attr('disabled', false);
                                    jAlert("Error when unlinking card. Please try again.");
                                }
                            },
                            error: function (response) {
                                that.$(".js-removeLinkedCard").removeClass("btn-showSpinner").attr('disabled', false);
                                jAlert("Error when unlinking card. Please try again.");
                            }
                        });
                        return this;
                    }
                });
            }

            return this;
        },
        checkFinRegStatus: function(callback){
            $.ajax({
                async: false,
                type: 'GET',
                url: pf.authURL + "/Token/CheckFin",
                contentType: "application/json",
                success: function (resp, model) {
                    if(callback){
                        callback(resp);
                    }
                },
                error: function (resp, model) {
                    if(resp.status == 401){
                        pf.session.cleanup(true);
                        $.fancybox.close();
                        pf.viewLogin(false, function(result){
                            var AccountView = null;
                            var options = options || {};
                            options = _.extend({ elementName: "#mainRegion" }, options);

                            var createNew = true;
                            // pf.require("views/accounts/accountsmain", options.subNav, null, createNew, function () {
                            //     require(["views/accounts/accountsmain"], function (AccountView) {
                            //         pf.show(new AccountView(options));
                            //         if(callback){
                            //             callback(true);
                            //         }
                            //     });
                            // });
                        }, null, {isNotPopup : false }, false);
                    }
                }
            });
        },
        saveLC: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var that = this;
            var updatedNN = this.$("#nickname").val();
            var lc = new LinkedCard(
               {
                   LGUID: this.LCGUID,
                   NN: updatedNN
               })

            $.ajax({
                type: 'PUT',
                url: pf.consumerURL + "/LinkedCards",
                data: JSON.stringify(lc),
                contentType: "application/json",
                success: function (model, resp) {
                    that.NickName = updatedNN;
                    that.LCEvents.trigger("updateCard", that.LCGUID, updatedNN);
                    jAlert("Successfully updated nickname.");
                    $.fancybox.close();
                },
                error: function (model, resp) {
                    jAlert("Error");
                }
            });
 
            
            return this;
        },
        removeLC: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var that = this;
            this.checkFinRegStatus(function(resp){
                if(resp == true){
                    pfdialog.confirm({
                        context: that,
                        Title  : "Unlink Card",
                        Body   : "Are you sure you want to unlink your card? You will cease to receive rebates for this card once you unlink it.",
                        okButtonText: "Yes",
                        cancelButtonText: "No",
                        okCallback: function(){
                            that.$(".js-removeLinkedCard").attr('disabled', true);
                            that.$(".js-removeLinkedCard").addClass("btn-showSpinner");
                            var data = { guid: that.LCGUID };
                            
                            $.ajax({
                                type : "POST",
                                url  : pf.consumerURL + "/RemoveLinkedCard",
                                async: false,
                                data : JSON.stringify(data),
                                contentType: "application/json",
                                success: function (response) {
                                    if (response) {
                                        that.$(".js-removeLinkedCard").removeClass("btn-showSpinner").attr('disabled', false);
                                        //jAlert("Card unlinked successfully");
                                        pfdialog.alert({
                                            context     : that.LCView,
                                            okButtonText: 'OK',
                                            Body        : 'Card unlinked successfully.',
                                            Title       : 'Success'
                                        });
                                        that.LCView.refreshCards(that.LCView);
                                        $.fancybox.close();
                                    }
                                    else {
                                        that.$(".js-removeLinkedCard").removeClass("btn-showSpinner").attr('disabled', false);
                                        jAlert("Error when unlinking card. Please try again.");
                                    }
                                },
                                error: function (response) {
                                    that.$(".js-removeLinkedCard").removeClass("btn-showSpinner").attr('disabled', false);
                                    jAlert("Error when unlinking card. Please try again.");
                                }
                            });
                            return that;
                        }
                    });
                }
            });
        },
        close: function () {
            $.fancybox.close();
        }
    });
});

